import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CHECKOUT_FEATURE } from './checkout-state';
import { reducerProvider, reducerToken } from './reducers';

@NgModule({
  imports: [StoreModule.forFeature(CHECKOUT_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class CheckoutStoreModule {}
